// frontend/src/components/Chatbot/chatUtils.ts
import { BookOpen, Calendar, Bookmark, GraduationCap, AlertCircle, type LucideIcon } from 'lucide-react';

/**
 * Get icon for action type based on tool name
 */
export const getActionIcon = (toolName: string | undefined | null, defaultIcon: LucideIcon = AlertCircle): LucideIcon => {
  if (toolName?.includes('course')) return BookOpen;
  if (toolName?.includes('semester')) return Calendar;
  if (toolName?.includes('bookmark')) return Bookmark;
  if (toolName?.includes('major') || toolName?.includes('minor') || toolName?.includes('plan')) return GraduationCap;
  return defaultIcon;
};
